import * as React from 'react';
import { Icon } from '@rocketmakers/armstrong';

import './message.scss';

export enum MessageTypes {
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
}

const messageIconMap = {
  [MessageTypes.Error]: Icon.Icomoon.cancelCircle2,
  [MessageTypes.Warning]: Icon.Icomoon.notification2,
  [MessageTypes.Success]: Icon.Icomoon.checkmarkCircle,
};

interface MessageProps extends React.PropsWithChildren<unknown> {
  type: MessageTypes;
  title: React.ReactNode;
}

export const Message: React.FunctionComponent<MessageProps> = ({ type, title, children }) => {
  return (
    <div className={`message ${type}`}>
      <h3>
        <Icon icon={messageIconMap[type]} /> <span>{title}</span>
      </h3>
      {children}
    </div>
  );
};
